import io, { Socket } from 'socket.io-client'
import { SOCKET_URL } from '../configs/config'

const socket = {
  instance: null as Socket | null,
  connect: (token: string) => {
    if (!token) throw new Error('cannot establish socket connection without token')
    socket.close()
    socket.instance = io(`${SOCKET_URL}?token=${token}`, {
      reconnection: true,
      reconnectionDelay: 500,
      reconnectionDelayMax: 500,
      reconnectionAttempts: Infinity,
      transports: ['websocket'],
      secure: true
    })
  },
  close: () => {
    if (socket.instance) {
      socket.instance.close()
      socket.instance = null
    }
  },
  on: (event: string, callback: (data: any) => void) => {
    if (socket.instance) {
      socket.instance.on(event, callback)
    }
  },
  off: (event: string, callback?: (data: any) => void) => {
    if (socket.instance) {
      socket.instance.off(event, callback)
    }
  },
  emit: (event: string, data?: any) => {
    if (socket.instance) {
      socket.instance.emit(event, data)
    }
  },
  isConnected: () => socket.instance?.connected || false
}

export default socket
